import { dispatch } from '../../store';
import {
  setConnectedState,
} from './realtimeSlice';

export const updateConnectedState = async (state: 'idle' | 'connected' | 'failed' | 'error') => {
  dispatch(setConnectedState(state));
};